export default import.meta.ROLLUP_FILE_URL_8p0a_Yl7A9Vdcy85$7MPeg